import React, { useCallback } from 'react'
import { Box, Text } from '@ui'
import { usePanelActions } from 'routes/layouts/hooks/usePanelActions'

import { TokenListSkeleton } from '../Wallet/TokenListSkeleton'

import { isNativeAsset, useMergedAssets } from './hooks/useMergedAssets'
import { AssetEntry } from './ui/AssetEntry'
import { ChainWalletAssets, MergedTradingAsset } from './tradingUtils'

export const TradingTokensList = ({
    assets,
    assetsError,
    isLoading,
}: {
    assets: ChainWalletAssets[]
    assetsError: Error | null
    isLoading: boolean
}) => {
    const { allAssets } = useMergedAssets({ assets })
    const { openPanel } = usePanelActions()

    const onClick = useCallback(
        (asset: MergedTradingAsset) => {
            if (isNativeAsset(asset)) {
                return
            }
            if (asset.tokenAddress && asset.chain) {
                openPanel('trade', {
                    mode: 'sell',
                    tokenAddress: asset.tokenAddress,
                    chainId: asset.chain,
                })
            }
        },
        [openPanel],
    )

    if (isLoading) {
        return <TokenListSkeleton />
    }

    return (
        <>
            {assetsError && (
                <Box
                    padding
                    alignItems="center"
                    textAlign="center"
                    paddingY="x4"
                    border="negative"
                    rounded="md"
                    background="negativeSubtle"
                >
                    <Text color="error">Unable to load token balances</Text>
                </Box>
            )}
            {allAssets.map((token) => (
                <AssetEntry
                    asset={token}
                    key={token.tokenAddress + token.chain}
                    onClick={() => onClick(token)}
                />
            ))}
        </>
    )
}
